/* eslint-disable */
import jsonBig from 'json-bigint'

/* @description Desktop Client 基类, 将桌面端提供的所有接口暴露给JS*/
class IDesktopClient {
  /* @description 构造函数*/
  constructor() { }
  /*
  @description 设置错误处理回调函数
  @params errorHandler:Function 错误处理回调函数, 其签名为: (errorCode:String, errorMessage:String) -> void
  @
  @return void
  */
  SetErrorHandler(errorHandler) {
    this.errorHandler = errorHandler
  }

  /*
  @description 检查response是否有错误, 若有则调用错误处理回调函数
  @params response IDesktopClient接口的响应结果
  @
  @return <response>
  */
  __FilterError(response) {
    if (response.code === 'success') {
      return response
    }
    if (typeof this.errorHandler === 'undefined' || this.errorHandler == null) {
      return response
    }

    this.errorHandler(response.code, response.message)
    return response
  }

  /*
  @description 获取桌面端提供的所有接口的默认响应结果
  @params void
  @
  @return 桌面端提供的所有接口的默认响应结果
  */
  #DefaultResponse() {
    return new Promise((resolve) => {
      resolve(
        this.__FilterError({
          code: 'request.method.not.found',
          message: 'not implemented!',
          data: null,
        })
      )
    })
  }

  /*
  @description 调用桌面端接口，通用入口
  @params method:String 要调用的桌面端函数签名
  @params params:Object 桌面端函数所需的参数
  @
  @return a Promise. resolve 的结果为：
      {
          code: String,
          message: String,
          data: <data>
      }
      code 为success表示成功
      data 为实际执行结果
  */
  CallDesktop(method, params) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，获取桌面端基本信息
  @params void
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: Object
      }
      code - 为success表示成功
      data - 桌面端基本信息，其结构为：
      {
        clientType: string,
        hostAppName: string,
        hostAppVersion: string,
        desktopName: string,
        desktopVersion: string,
        hostPlatformCode: string,
        hostAppName: string,
        hostAppVersion: string,
        pluginName: string,
        pluginVersion: string,
        machineCode: string,
        osVersion: string,
        screenResolutions: string
      }
  */
  GetDesktopInfo() {
    return this.#DefaultResponse()
  }

  /*
   @description 调用桌面端，获取当前用户信息
   @params void
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: Object
       }
       code - 为success表示成功,
       data - 当前用户的信息, 若没有则为null, 其结构为:
       {
           id: String, 用户ID
           name: String, 用户名称
           accessToken: String, 访问令牌
       }
  */
  GetUserInfo() {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，打开默认浏览器跳转到指定链接
  @params targetUrl:String 要打开的目标链接
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  NavigateToBrowser(targetUrl) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，获取特殊目录的地址
  @params type:String 特殊目录类型，可选值如下：
               'LocalApplicationData' - 本地应用程序数据目录，对应环境变量%localappdata%
               'UserProfile' - 用户档案目录，对应环境变量%userprofile%
               'Temporary' - 临时目录，对应环境变量%temp%
               ...
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: String
      }
      code - 为success表示成功
      data - 对应的特殊目录的全路径
  */
  GetSpecialFolder(type) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，删除文件
  @params filePath:String 文件路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  DeleteFile(filePath) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，批量删除文件
  @params dirPath:String 文件夹地址
  @params recursive:bool 是否递归查找子目录，默认false
  @params filter:String 要删除文件的过滤器，例如：'*.rvt|*.dwg'，默认为全部(*.*）
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  DeleteFiles(dirPath, recursive, filter) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，检查文件是否存在
  @params filePath:String 文件路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若存在，则为true，否则，为false
  */
  ExistFile(filePath) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，检查文件夹是否存在
  @params dirPath:String 文件夹路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若存在，则为true，否则，为false
  */
  ExistDirectory(dirPath) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，创建文件夹
  @note 任一层级上的文件夹若不存在，则均会进行创建
  @params dirPath:String 文件夹路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  CreateDirectory(dirPath) {
    return this.#DefaultResponse()
  }

  /*
 @description 调用桌面端，选择本地文件夹
 @params options:Object 选项，其结构如下：
     {
      initialDirectory:String, 初始目录
      description:String, 描述
      showNewFolderButton:bool, 是否显示新建文件夹按钮(仅对普通对话框生效)
      useFolderBrowserDialog:bool, 是否使用普通的文件夹选择对话框，默认false
   }
 @
 @return a Promise. resolve 结果为:
     {
         code: String,
         message: String,
         data: Object
     }
     code - 为success表示成功
     data - 文件选择结果，其结构为：
     {
         isCanceled: bool, 用户是否取消选择
         selectedDirectory: string, 所选的文件夹路径
     }
 */
  SelectDirectory(options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，判断文件夹是否为空
  @params dirPath:String 文件夹路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若为空，则为true，否则，为false
  */
  IsDirectoryEmpty(dirPath) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，删除文件夹
  @params dirPath:String 文件夹路径
  @params recursive:Boolean 是否递归删除文件夹内所有内容，包括子文件夹
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  DeleteDirectory(dirPath, recursive) {
    return this.#DefaultResponse()
  }

  /*
@description 调用桌面端，在资源管理器中显示指定路径的文件或文件夹
@params path:String 文件或文件夹路径
@
@return a Promise. resolve 结果为：
    {
        code: String,
        message: String,
        data: void
    }
    code - 为success表示成功
*/
  RevealInExplorer(path) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，开启磁盘文件迁移程序
  @params options:Object, 磁盘文件迁移选项，其结构为：
      {
        srcPath:String, 源文件夹路径
        destPath:String, 目标文件夹路径
        bannedProcesses: array<String>, 迁移时需禁止的进程名称列表
        finishAction:  迁移结束后的行为
        {
          type: String, 行为类型(UpdateConfig-更新配置文件, ...)
          params:
          {
            configPath: String, 要更新的配置文件路径
            configItems:[ 要更新的配置项列表
              {
                 key: String, 配置项的键(使用jsonPath)
                 value:String, 配置项的值
              }
            ]
          }
        }
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功,
      data - 返回迁移程序信息和状态，其结构为：
      {
         status: String, 当前状态(Started-已开启，ShortOut-已短路，即快速成功),
         program: String, 迁移程序地址
      }
  */
  StartMigration(options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，校正文件夹快捷方式(Junction)
  @params srcPath:String, 源文件夹路径
  @params destPath:String, 目标文件夹路径
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示开启成功
  */
  RectifyJunction(srcPath, destPath) {
    return this.#DefaultResponse()
  }

  /*
   @description 调用桌面端，获取文件夹大小
   @params dirPath:String, 文件夹路径
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: String
       }
       code - 为success表示成功,
       data - 文件夹大小，单位为字节
  */
  GetDirectorySize(dirPath) {
    return this.#DefaultResponse()
  }

  /*
   @description 调用桌面端，获取路径所在磁盘的信息
   @params path:String, 文件或文件夹路径
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: Object
       }
       code - 为success表示成功,
       data - 路径所在磁盘的信息，其结构为：
      {
         availableSize: String, 可用空间大小，单位为字节
         totalSize: String, 总空间大小，单位为字节
      }
  */
  GetDriveInfo(path) {
    return this.#DefaultResponse()
  }
  /*
  @description 调用桌面端，从文件夹创建压缩文件
  @params options:Object 选项，其结构如下：
      {
        srcDirPath:String, 要压缩的源文件夹的路径
        destZipFilePath:String, 要生成的目标压缩文件的路径
        compressionLevel:String, 压缩级别（可选），默认为Optimal，可选值如下：
                                "Optimal", 最优
                                "Fastest", 最快
                                "NoCompression", 无压缩
        includeBaseDirectory:Boolean, 是否包含源文件夹本身（可选），默认为false
        entryNameEncoding:String, 压缩项名称编码（可选），默认为null
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示开启成功
  */
  CreateZipFromDirectory(options) {
    return this.#DefaultResponse()
  }
  /*
  @description 调用桌面端，将压缩文件解压提取到指定文件夹内
  @params options:Object 选项，其结构如下：
      {
        srcZipFilePath:String, 要解压的压缩文件的路径
        destDirPath:String, 要解压到的文件夹的路径
        entryNameEncoding:String, 压缩项名称编码（可选），默认为null
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示开启成功
  */
  ExtractZipToDirectory(options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，从文件中读取文本
  @params filePath:String 文件路径
  @params encoding:String 编码类型，默认UTF-8
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: String
      }
      code - 为success表示成功
      data - 文本内容
  */
  ReadTextFromFile(filePath, encoding) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，向文件中写入文本
  @note 若文件存在，则内容会被覆盖
  @params filePath:String 文件路径
  @params content:String 文本内容
  @params encoding:String 编码类型，默认UTF-8
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  WriteTextToFile(filePath, content, encoding) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，复制文件
  @params srcFilePath:String 源文件路径
  @params destFilePath:String 目标文件路径
  @params overwrite:bool 若目标文件已存在，是否覆盖，默认为true
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  CopyFile(srcFilePath, destFilePath, overwrite) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，从远程下载文件
  @params remoteUrl:String 远程Url地址
  @params localFilePath:String 本地文件路径
  @params overwrite:bool 若本地文件已存在，是否覆盖，默认为true
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  DownloadFile(remoteUrl, localFilePath, overwrite) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，从远程下载文件(支持取消)
  @params remoteUrl:String 远程Url地址
  @params localFilePath:String 本地文件路径
  @params overwrite:bool 若本地文件已存在，是否覆盖，默认为true
  @params cancelToken:string 用于取消的令牌，可使用GUID
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
      data - 若成功，则为true，否则，为false
  */
  DownloadFileCancelable(remoteUrl, localFilePath, overwrite, cancelToken) {
    return this.#DefaultResponse()
  }

  /*
      @description 调用桌面端，取消指定任务
      @params cancelToken:string 用于取消的令牌，可使用GUID
      @
      @return a Promise. resolve 结果为:
          {
              code: String,
              message: String,
              data: bool
          }
          code - 为success表示成功
          data - 若成功，则为true，否则，为false
      */
  CancelTask(cancelToken) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，获取文件的MD5
  @params filePath:String 文件路径
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: String
      }
      code - 为success表示成功
      data - MD5
  */
  GetFileMd5(filePath) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，开启当前窗口蒙层
  @params options:Object 选项，其结构如下：
      {
       region:String, 蒙层区域，可选值如下：
               "R_TITLE_BAR", 标题栏
               "R_CLIENT_AREA", 客户区
               "R_OVERALL", 全部
               ...
      }
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
      data - void
  */
  ShowMask(options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，关闭当前窗口蒙层
  @params options:Object 选项，其结构如下：
      {
       region:String, 蒙层区域，可选值如下：
               "R_TITLE_BAR", 标题栏
               "R_CLIENT_AREA", 客户区
               "R_OVERALL", 全部
               ...
      }
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
      data - void
  */
  HideMask(options) {
    return this.#DefaultResponse()
  }

  /*
   @description 调用桌面端，根据一组构件名称获取当前文档中的的构件信息
   @params componentNames:array<String> 构件名称列表
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: array<Object>
       }
       code - 为success表示成功
       data - 通过名称匹配到的构件对象列表，其结构为：
       [
           {
             familyName: String,     // 构件名称
             familyId: String,       // 构件ElementId
             instanceCount: Integer, // 构件对应的实例数量
           }
       ]
   */
  ListComponentsByNames(componentNames) {
    return this.#DefaultResponse()
  }

  /*
   @description 调用桌面端，载入构件
   @params options:Object, 构件载入选项，其结构为：
        {
          userId:String, 用户ID
          softwareVersionId:Long, 构件资源软件版本ID
          dataVersionId:Long, 构件资源数据版本ID
          name:String, 构件名称
          suffix:String, 构件后缀（不含点）
          filePath: String, 构件文件路径
          familyFoundStrategy: String, 若发现同名构件应采取的策略，可选值如下：
                                "FFS_CREATE", 重命名后创建新的族
                                "FFS_OVERWRITE", 覆盖已有的同名的族
        }
    @
    @return a Promise. resolve 结果为：
        {
            code: String,
            message: String,
            data: void
        }
        code - 为success表示成功
  */
  LoadComponent(options) {
    return this.#DefaultResponse()
  }

  /*
     @description 调用桌面端，载入构件
     @params options:Array[Object], 构件载入选项，其结构为：
          [{
            userId:Long, 用户ID
            softwareVersionId:Long, 构件资源软件版本ID
            dataVersionId:Long, 构件资源数据版本ID
            name:String, 构件名称
            suffix:String, 构件后缀（不含点）
            filePath: String, 构件文件路径
          }]
      @
      @return a Promise. resolve 结果为：
          {
              code: String,
              message: String,
              data: Object
          }
          code - 为success表示成功
          data - 载入后的构件信息，其结构为：[]
    */
  LoadComponents(options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，布置构件
  @params options:Object, 构件布置选项，其结构为：
      {
        userId:String, 用户ID
        softwareVersionId:Long, 构件资源软件版本ID
        dataVersionId:Long, 构件资源数据版本ID
        name:String, 构件名称
        suffix:String, 构件后缀（不含点）
        filePath: String, 构件文件路径
        familyFoundStrategy: String, 若发现同名构件应采取的策略，可选值如下：
                              "FFS_CREATE", 重命名后创建新的族
                              "FFS_OVERWRITE", 覆盖已有的同名的族
        familyId: String, 要布置的族ElementId
        typeNameToBePlaced:String, 要布置的族类型名称
        loadAllTypes:bool, 是否载入所有族类型
        typeNames:Array<String>, 所有族类型名称列表
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  PlaceComponent(options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，根据文件所在目录获取模型链接
  @params dirPath:String 文件所在目录地址
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: array<Object>
      }
      code - 为success表示成功
      data - 模型链接对象列表，其结构为：
      [
          {
            linkId: Long,       // 模型链接ElementId
            linkPath: String,   // 模型链接文件路径
          }
      ]
  */
  ListModelLinksByDirPath(dirPath) {
    return this.#DefaultResponse()
  }

  /*
      @description 调用桌面端，链接模型
      @params options:Object, 选项，其结构为：
          {
            userId:String, 用户ID
            fileId:Long, 文件ID
            fileRevisionId:Long, 文件修订版本ID
            filePath: String, 文件路径
            placement:String, 定位方式，可选值如下：
                     "P_AUTO_CENTERED", 自动 - 中心到中心
                     "P_AUTO_ORIGIN", 自动 - 内部原点到内部原点
                     "P_AUTO_SHARED", 自动 -  通过共享坐标
                     "P_AUTO_SITE", 自动 - 项目基点到项目基点
                     "P_MANUAL_ORIGIN", 手动 - 内部原点
                     "P_MANUAL_SITE", 手动 - 基点
                     "P_MANUAL_CENTERED", 手动 - 中心
                     ...
          }
      @
      @return a Promise. resolve 结果为：
          {
              code: String,
              message: String,
              data: void
          }
          code - 为success表示成功
      */
  LinkModel(options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，重新载入模型链接
  @params linkId:Long, 要重载的模型链接的ElementId
  @params options:Object, 选项，其结构为：
       {
         userId:String, 用户ID
         fileId:Long, 文件ID
         fileRevisionId:Long, 文件修订版本ID
       }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ReloadModelLink(linkId, options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，重新载入模型链接，来自新的位置
  @params filePath:String, 新的文件位置
  @params linkId:Long, 要重载的模型链接的ElementId
  @params options:Object, 选项，其结构为：
      {
        userId:String, 用户ID
        fileId:Long, 文件ID
        fileRevisionId:Long, 文件修订版本ID
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ReloadModelLinkFrom(filePath, linkId, options) {
    return this.#DefaultResponse()
  }

  /*
      @description 调用桌面端，根据文件所在目录获取CAD链接
      @params dirPath:String 文件所在目录地址
      @
      @return a Promise. resolve 结果为：
          {
              code: String,
              message: String,
              data: array<Object>
          }
          code - 为success表示成功
          data - CAD链接对象列表，其结构为：
          [
              {
                linkId: Long,       // CAD链接ElementId
                linkPath: String,   // CAD链接文件路径
              }
          ]
      */
  ListCADLinksByDirPath(dirPath) {
    return this.#DefaultResponse()
  }

  /*
      @description 调用桌面端，获取当前视图信息
      @params void
      @
      @return a Promise. resolve 结果为：
          {
              code: String,
              message: String,
              data: Object
          }
          code - 为success表示成功
          data - 当前视图信息，其结构为：
          {
              viewId: Long,       // 视图ElementId
              viewType: String,   // 视图类型，可选值如下：
                                      "FloorPlan", 楼层平面
                                      "CeilingPlan", 天花板平面
                                      "AreaPlan", 面积平面
                                      "Elevation", 立面
                                      "ThreeD", 三维
                                      ...
              title: String,      // 视图标题
              genLevelId: Long    // 生成此视图所基于的标高ElementId
          }
      */
  GetActiveView() {
    return this.#DefaultResponse()
  }

  /*
      @description 调用桌面端，获取标高列表
      @params void
      @
      @return a Promise. resolve 结果为：
          {
              code: String,
              message: String,
              data: array<Object>
          }
          code - 为success表示成功
          data - 标高列表，其结构为：
          [
              {
                  levelId:Long,       // 标高ElementId
                  elevation:double,   // 高度
                  name:String,        // 名称
                  ownerViewId:Long,   // 所属视图ElementId
              }
          ]
      */
  ListLevels() {
    return this.#DefaultResponse()
  }

  /*
      @description 调用桌面端，链接CAD
      @params options:Object, CAD链接选项，其结构为：
           {
             userId:String, 用户ID
             filedId:Long, 文件ID
             fileRevisionId:Long, 文件修订版本ID
             filePath: String, 业务所需文件路径
             placement:String, 定位方式，可选值如下：
                      "P_AUTO_CENTERED", 自动 - 中心到中心
                      "P_AUTO_ORIGIN", 自动 - 内部原点到内部原点
                      "P_AUTO_SHARED", 自动 -  通过共享坐标
                      "P_AUTO_SITE", 自动 - 项目基点到项目基点
                      "P_MANUAL_ORIGIN", 手动 - 内部原点
                      "P_MANUAL_SITE", 手动 - 基点
                      "P_MANUAL_CENTERED", 手动 - 中心
                      ...
             colorMode:String, 颜色模式，可选值如下：
                      "CM_PRESERVED", 保留
                      "CM_INVERTED", 反选
                      "CM_BLACK_AND_WHITE", 黑白
             layerMode:String, 图层导入模式，可选值如下：
                      "LM_ALL", 全部
                      "LM_VISIBLE_ONLY", 可见
                      "LM_SPECIFIED", 指定
             unit:String, 单位，可选值如下：
                      "UT_DEFAULT", 默认
                      "UT_FOOT", 英尺
                      "UT_INCH", 英寸
                      "UT_METER, 米
                      "UT_DECIMETER", 分米
                      "UT_CENTIMETER", 厘米
                      "UT_MILLIMETER", 毫米
                      "UT_CUSTOM", 自定义
             customScale:double, 自定义缩放系数
             levelId:Long, 标高ElementId
             thisViewOnly:bool, 是否仅当前视图
             orientToView:bool, 是否定向到视图
             autoCorrectAlmostVHLines:bool, 是否纠正稍微偏离轴的线
           }
      @
      @return a Promise. resolve 结果为：
          {
              code: String,
              message: String,
              data: void
          }
          code - 为success表示成功
      */
  LinkCAD(options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，重新载入CAD链接
  @params linkId:Long, 要重载的CAD链接的ElementId
  @params options:Object, 选项，其结构为：
      {
        userId:String, 用户ID
        fileId:Long, 文件ID
        fileRevisionId:Long, 文件修订版本ID
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ReloadCADLink(linkId, options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，重新载入CAD链接
  @params filePath:String, 新的文件位置
  @params linkId:Long, 要重载的CAD链接的ElementId
  @params options:Object, 选项，其结构为：
      {
        userId:String, 用户ID
        fileId:Long, 文件ID
        fileRevisionId:Long, 文件修订版本ID
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ReloadCADLinkFrom(filePath, linkId, options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，导入CAD
  @params options:Object, CAD导入选项，其结构为：
      {
        userId:Long, 用户ID
        fileId:Long, 文件ID
        fileRevisionId:Long, 文件修订版本ID
        filePath: String, 文件路径
        placement:String, 定位方式，可选值如下：
                 "P_AUTO_CENTERED", 自动 - 中心到中心
                 "P_AUTO_ORIGIN", 自动 - 内部原点到内部原点
                 "P_AUTO_SHARED", 自动 -  通过共享坐标
                 "P_AUTO_SITE", 自动 - 项目基点到项目基点
                 "P_MANUAL_ORIGIN", 手动 - 内部原点
                 "P_MANUAL_SITE", 手动 - 基点
                 "P_MANUAL_CENTERED", 手动 - 中心
                 ...
        colorMode:String, 颜色模式，可选值如下：
                 "CM_PRESERVED", 保留
                 "CM_INVERTED", 反选
                 "CM_BLACK_AND_WHITE", 黑白
        layerMode:String, 图层导入模式，可选值如下：
                 "LM_ALL", 全部
                 "LM_VISIBLE_ONLY", 可见
                 "LM_SPECIFIED", 指定
        unit:String, 单位，可选值如下：
                 "UT_DEFAULT", 默认
                 "UT_FOOT", 英尺
                 "UT_INCH", 英寸
                 "UT_METER, 米
                 "UT_DECIMETER", 分米
                 "UT_CENTIMETER", 厘米
                 "UT_MILLIMETER", 毫米
                 "UT_CUSTOM", 自定义
                 "UT_US_SURVEY_FOOT", 美制测量英尺
        customScale:double, 自定义缩放系数
        levelId:Long, 标高ElementId
        thisViewOnly:bool, 是否仅当前视图
        orientToView:bool, 是否定向到视图
        autoCorrectAlmostVHLines:bool, 是否纠正稍微偏离轴的线
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  ImportCAD(options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，打开选择文件对话框进行文件选择
  @params options:Object 选项，其结构如下：
      {
       title:String, 窗口标题
       filter:String, 文件类型过滤器，例如："Revit族文件(*.rfa)|*.rfa|Revit项目文件(*.rvt)|*.rvt"
       initialDirectory:String, 初始目录
       restoreDirectory:bool, 是否恢复目录
       multiselect:bool, 是否支持多选
       checkFileExists:bool, 是否校验文件存在
       checkPathExists:bool, 是否校验路径存在
       dereferenceLinks:bool, 是否解引用快捷方式链接
      }
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: Object
      }
      code - 为success表示成功
      data - 文件选择结果，其结构为：
      {
          isCanceled: bool, 用户是否取消选择
          selectedFiles: Array<string>, 所选的文件路径列表
      }
  */
  SelectFiles(options) {
    return this.#DefaultResponse()
  }

  /*
  @description 调用桌面端，设置文本到剪切板
  @params text:String 要复制的文本
  @
  @return a Promise. resolve 结果为:
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
      data - void
  */
  ClipboardSetText(text) {
    return this.#DefaultResponse()
  }

  /*
   @description 调用桌面端，载入模块
   @params options:Object, 模块载入选项，其结构为：
        {
          userId:Long, 用户ID
          softwareVersionId:Long, 资源软件版本ID
          dataVersionId:Long, 资源数据版本ID
          name:String, 名称
          suffix:String, 后缀（不含点）
          filePath: String, 文件路径
          guid: String, 主模块GUID
          type: String, 模块类型
          functionType: String, 功能类型
          specialtyType: String, 专业类型
          moduleName: String, 模块名
          moduleFileName: String, 模块文件名
          metaJson: String, 模块meta.json内容
        }
    @
    @return a Promise. resolve 结果为：
        {
            code: String,
            message: String,
            data: void
        }
        code - 为success表示成功
  */
  LoadModule(options) {
    return this.#DefaultResponse()
  }

  /*
   @description 调用桌面端，载入模板
   @params options:Object, 模板载入选项，其结构为：
        {
          filePath: String, 文件路径
        }
    @
    @return a Promise. resolve 结果为：
        {
            code: String,
            message: String,
            data: void
        }
        code - 为success表示成功
  */
  LoadTemplate(options) {
    return this.#DefaultResponse()
  }

  /*
   @description 调用桌面端，打开并激活文档
   @params options:Object, 打开文档选项，其结构为：
      {
        userId:String, 用户ID
        spaceId:String, 空间ID,
        fileId:String, 文件ID
        fileType:String, 文件类型
        fileRevisionId:String, 文件修订版本ID
        filePath:String, 文件路径
        fileName:String, 文件名称
        fileSuffix:String, 文件后缀
      }
   @
   @return a Promise. resolve 结果为：
       {
           code: String,
           message: String,
           data: Object
       }
       code - 为success表示成功,
       data - 所打开文档的信息, 其结构为:
       {
           title: String, 文档标题
           pathName: String, 文档全路径
           isFamilyDocument: bool, 是否为族文档
           isInTransaction: bool, 是否处于事务中
           isLinked: bool, 是否为链接文档
       }
  */
  OpenAndActivateDocument(options) {
    return this.#DefaultResponse();
  }

  /*
  @description 调用桌面端，在浏览器内模拟鼠标点击
  @params options:Object 选项，其结构如下：
      {
        x:Number, X坐标
        y:Number, Y坐标
        mouseButtonType:String, 鼠标按钮类型，可选值有：
                    Left - 鼠标左键
                    Middle - 鼠标中键
                    Right - 鼠标右键
        modifiers:String, 键盘修改键标志位，可选值有：
                    None - 0 - 无
                    ShiftDown - 2 - 按下Shift
                    ControlDown - 4 - 按下Control
                    AltDown - 8 - 按下Alt
                    ...
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
  */
  PerformMouseClickInBrowser(options) {
    return this.#DefaultResponse();
  }

  /*
  @description 调用桌面端，在浏览器内打开对话框时自动选择指定路径
  @params options:Object 选项，其结构如下：
      {
        autoSelectPaths:Array<string>, 指定要自动选择的路径，一个或多个
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: bool
      }
      code - 为success表示成功
  */
  SetDialogAutoSelectInBrowser(options) {
    return this.#DefaultResponse();
  }

  /*
  @description 调用桌面端，发布Web事件
  @params options:Object 选项，其结构如下：
      {
        eventName:string, 事件名称
        eventArgs:string, 事件参数
      }
  @
  @return a Promise. resolve 结果为：
      {
          code: String,
          message: String,
          data: void
      }
      code - 为success表示成功
  */
  EmitWebEvent(options) {
    return this.#DefaultResponse();
  }
  /*
    @description 调用桌面端，链接IFC
    @params options:Object, IFC链接选项，其结构为：
         {
           filePath: String, 文件路径
           fileNameSame:bool, 是否文件名重复链接IFC（默认：true）
           tryRelativeType:bool, 使用相对或绝对路径（默认：true，相对路径）
         }
    @
    @return a Promise. resolve 结果为：
        {
            code: String,
            message: String,
            data: void
        }
        code - 为success表示成功
    */
  LinkIFC(options) {
    return this.#DefaultResponse();
  }
  /*
    @description 调用桌面端，重新载入模型链接，来自新的位置
    @params filePath:String, 新的文件位置
    @params linkId:Long, 要重载的模型链接的ElementId
    @params options:Object, 选项，其结构为：
        {
          userId:String, 用户ID
          fileId:Long, 文件ID
          fileRevisionId:Long, 文件修订版本ID
        }
    @
    @return a Promise. resolve 结果为：
        {
            code: String,
            message: String,
            data: void
        }
        code - 为success表示成功
    */
  ReloadIFCLinkFrom(filePath, linkId, options) {
    return this.#DefaultResponse();
  }
}

/* @description Desktop Client 扩展类, 适配未知的桌面端版本*/
class DesktopClient_None extends IDesktopClient {
  /* @description 构造函数*/
  constructor() {
    super()
  }
}

/* @description Desktop Client 扩展类, 适配1.0.0.0及之后的桌面端版本*/
class DesktopClient_Since_1_0_0_0 extends IDesktopClient {
  /* @description 构造函数*/
  constructor() {
    super()
  }

  /* @description 确保interop对象已绑定*/
  async __EnsureCefSharpObjectBound() {
    if (typeof CefClient !== 'undefined') {
      return
    }

    try {
      /* 对于高版本CefSharp库, 须执行此语句, 低版本CefSharp执行此语句会出错, 为了兼容, 这里在try catch内进行调用 */
      // eslint-disable-next-line no-undef
      await CefSharp.BindObjectAsync('CefClient')
    } catch (e) {
      /* ignored */
    }
  }

  /* @description 接口实现*/
  async CallDesktop(method, params) {
    try {
      await this.__EnsureCefSharpObjectBound()
      if (typeof CefClient === 'undefined') {
        return this.__FilterError({
          code: 'failure',
          message: 'CefClient is undefined!',
          data: null,
        })
      }

      const requestObj = {
        path: method,
        params: params,
      }

      const responseStr = await CefClient.Send(JSON.stringify(requestObj))
      const json = jsonBig({
        storeAsString: true
      })
      return this.__FilterError(json.parse(responseStr))
    } catch (e) {
      return this.__FilterError({
        code: 'failure',
        message: e.toString(),
        data: null,
      })
    }
  }

  /* @description 接口实现*/
  async GetDesktopInfo() {
    const method = 'gjw/desktop/common/v1/desktop_info'
    const params = {}

    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async GetUserInfo() {
    const method = 'gjw/desktop/user/info'
    const params = {}
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async NavigateToBrowser(targetUrl) {
    const method = 'gjw/desktop/common/v1/navigate_to_browser'
    const params = {
      targetUrl: targetUrl,
    }

    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async GetSpecialFolder(type) {
    const method = 'gjw/desktop/fs/special_folder'
    const params = {
      type: type,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async DeleteFile(filePath) {
    const method = 'gjw/desktop/fs/delete_file'
    const params = {
      filePath: filePath,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async DeleteFiles(dirPath, recursive, filter) {
    const method = 'gjw/desktop/fs/delete_files'
    const params = {
      dirPath: dirPath,
      recursive: recursive,
      filter: filter,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ExistFile(filePath) {
    const method = 'gjw/desktop/fs/exist_file'
    const params = {
      filePath: filePath,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ExistDirectory(dirPath) {
    const method = 'gjw/desktop/fs/exist_directory'
    const params = {
      dirPath: dirPath,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async CreateDirectory(dirPath) {
    const method = 'gjw/desktop/fs/create_directory'
    const params = {
      dirPath: dirPath,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async SelectDirectory(options) {
    const method = 'gjw/desktop/fs/select_directory'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }
  /* @description 接口实现*/
  async IsDirectoryEmpty(dirPath) {
    let method = "gjw/desktop/fs/is_directory_empty"
    let params = {
      dirPath: dirPath,
    };
    return await this.CallDesktop(method, params);
  }

  /* @description 接口实现*/
  async DeleteDirectory(dirPath, recursive) {
    let method = "gjw/desktop/fs/delete_directory";
    let params = {
      dirPath: dirPath,
      recursive: recursive
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async RevealInExplorer(path) {
    const method = 'gjw/desktop/fs/reveal_in_explorer'
    const params = {
      path: path,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async StartMigration(options) {
    const method = 'gjw/desktop/fs/start_migration'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async RectifyJunction(srcPath, destPath) {
    const method = 'gjw/desktop/fs/rectify_junction'
    const params = {
      srcPath: srcPath,
      destPath: destPath,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async GetDirectorySize(dirPath) {
    const method = 'gjw/desktop/fs/dir_size'
    const params = {
      dirPath: dirPath,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async GetDriveInfo(path) {
    const method = 'gjw/desktop/fs/drive_info'
    const params = {
      path: path,
    }
    return await this.CallDesktop(method, params)
  }
  /* @description 接口实现*/
  async CreateZipFromDirectory(options) {
    let method = "gjw/desktop/compression/create_zip_from_directory";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ExtractZipToDirectory(options) {
    let method = "gjw/desktop/compression/extract_zip_to_directory";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }

  /* @description 接口实现*/
  async ReadTextFromFile(filePath, encoding) {
    const method = 'gjw/desktop/fs/read_text_from_file'
    const params = {
      filePath: filePath,
      encoding: encoding,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async WriteTextToFile(filePath, content, encoding) {
    const method = 'gjw/desktop/fs/write_text_to_file'
    const params = {
      filePath: filePath,
      content: content,
      encoding: encoding,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async CopyFile(srcFilePath, destFilePath, overwrite) {
    const method = 'gjw/desktop/fs/copy_file'
    const params = {
      srcFilePath: srcFilePath,
      destFilePath: destFilePath,
      overwrite: overwrite,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async DownloadFile(remoteUrl, localFilePath, overwrite) {
    const method = 'gjw/desktop/fs/download_file'
    const params = {
      remoteUrl: remoteUrl,
      localFilePath: localFilePath,
      overwrite: overwrite,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async DownloadFileCancelable(
    remoteUrl,
    localFilePath,
    overwrite,
    cancelToken
  ) {
    const method = 'gjw/desktop/fs/download_file_cancelable'
    const params = {
      remoteUrl: remoteUrl,
      localFilePath: localFilePath,
      overwrite: overwrite,
      cancelToken: cancelToken,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async CancelTask(cancelToken) {
    const method = 'gjw/desktop/task/cancel'
    const params = {
      cancelToken: cancelToken,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async GetFileMd5(filePath) {
    const method = 'gjw/desktop/fs/file_md5'
    const params = {
      filePath: filePath,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ShowMask(options) {
    const method = 'gjw/desktop/window/mask/show'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async HideMask(options) {
    const method = 'gjw/desktop/window/mask/hide'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ListComponentsByNames(componentNames) {
    const method = 'gjw/desktop/component/list_by_names'
    const params = {
      componentNames: componentNames,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async LoadComponent(options) {
    const method = 'gjw/desktop/component/load'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async LoadComponents(options) {
    let method = "gjw/desktop/component/batch/load"
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async PlaceComponent(options) {
    const method = 'gjw/desktop/component/place'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ListModelLinksByDirPath(dirPath) {
    const method = 'gjw/desktop/model/link/list_by_dir_path'
    const params = {
      dirPath: dirPath,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async LinkModel(options) {
    const method = 'gjw/desktop/model/link'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ReloadModelLink(linkId, options) {
    const method = 'gjw/desktop/model/link/reload'
    const params = {
      linkId: linkId,
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ReloadModelLinkFrom(filePath, linkId, options) {
    const method = 'gjw/desktop/model/link/reload_from'
    const params = {
      filePath: filePath,
      linkId: linkId,
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ListCADLinksByDirPath(dirPath) {
    const method = 'gjw/desktop/cad/link/list_by_dir_path'
    const params = {
      dirPath: dirPath,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async GetActiveView() {
    const method = 'gjw/desktop/view/active'
    const params = {}
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ListLevels() {
    const method = 'gjw/desktop/level/list'
    const params = {}
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async LinkCAD(options) {
    const method = 'gjw/desktop/cad/link'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ReloadCADLink(linkId, options) {
    const method = 'gjw/desktop/cad/link/reload'
    const params = {
      linkId: linkId,
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ReloadCADLinkFrom(filePath, linkId, options) {
    const method = 'gjw/desktop/cad/link/reload_from'
    const params = {
      filePath: filePath,
      linkId: linkId,
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ImportCAD(options) {
    const method = 'gjw/desktop/cad/import'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async SelectFiles(options) {
    const method = 'gjw/desktop/fs/select_files'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async ClipboardSetText(text) {
    const method = 'gjw/desktop/clipboard/set_text'
    const params = {
      text: text,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async LoadModule(options) {
    const method = 'gjw/desktop/module/load'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async LoadTemplate(options) {
    const method = 'gjw/desktop/template/load'
    const params = {
      options: options,
    }
    return await this.CallDesktop(method, params)
  }

  /* @description 接口实现*/
  async OpenAndActivateDocument(options) {
    let method = "gjw/desktop/document/open_and_activate";
    let params = {
      filePath: options.filePath,
    };
    return await this.CallDesktop(method, params);
  }
}

/* @description Desktop Client 扩展类, 适配1.3.0.0及之后的桌面端版本*/
class DesktopClient_Since_1_3_0_0 extends DesktopClient_Since_1_0_0_0 {
  /* @description 构造函数*/
  constructor() {
    super();
  }
  /* @description 接口实现*/
  async OpenAndActivateDocument(options) {
    let method = "gjw/desktop/document/open_and_activate";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async PerformMouseClickInBrowser(options) {
    let method = "gjw/desktop/browser/perform_mouse_click";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async SetDialogAutoSelectInBrowser(options) {
    let method = "gjw/desktop/browser/set_dialog_auto_select";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async EmitWebEvent(options) {
    let method = "gjw/desktop/web_event/emit";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async LinkIFC(options) {
    let method = "gjw/desktop/ifc/link";
    let params = {
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
  /* @description 接口实现*/
  async ReloadIFCLinkFrom(filePath, linkId, options) {
    let method = "gjw/desktop/ifc/link/reload_from";
    let params = {
      filePath: filePath,
      linkId: linkId,
      options: options,
    };
    return await this.CallDesktop(method, params);
  }
}

/* @description Desktop Client 工厂类, 自动根据桌面端版本号, 创建对应的Desktop Client实例*/
class DesktopClientFactory {
  /* @description 构造函数*/
  constructor() {
    this.availableClientTypes = [
      { sinceVersion: '0.0.0.0', clientType: DesktopClient_None },
      { sinceVersion: '1.0.0.0', clientType: DesktopClient_Since_1_0_0_0 },
      { sinceVersion: "1.3.0.0", clientType: DesktopClient_Since_1_3_0_0 },
    ] // 版本号须按递增顺序
  }

  static #_factory = null;
  /* @description DesktopClientFactory工厂单例*/
  static get Factory() {
    if (!this.#_factory) {
      this.#_factory = new DesktopClientFactory()
    }

    return this.#_factory
  }

  /*
  @description 将桌面端版本号拆分为4位数字
  @params version:String 桌面端版本号
  @
  @return versionParts:Int[4]. 点分版本号数组, 元素类型为Integer, 数组长度为4
  */
  #SplitDesktopVersion(version) {
    let adjustedVersion = version.trim()

    // 处理带'V'的老版本号
    if (adjustedVersion.startsWith('V')) {
      adjustedVersion = adjustedVersion.substring(1).trim()
    }

    const versionNumbers = []
    const versionParts = adjustedVersion.split('.')
    const count = versionParts.length
    for (let i = 0; i < count; ++i) {
      versionNumbers.push(parseInt(versionParts[i]))
    }

    // 补.齐版本号为4位
    for (let i = count; i < 4; ++i) {
      versionNumbers.push(0)
    }

    return versionNumbers
  }

  /*
  @description 比较桌面端版本号
  @params version1:String 桌面端版本号1
  @params version2:String 桌面端版本号2
  @
  @return an Integer. 若version1 > version2, 则返回正数; 若version1 < version2, 则返回负数; 否则返回0
  */
  #CompareDesktopVersion(version1, version2) {
    const version1Numbers = this.#SplitDesktopVersion(version1)
    const version2Numbers = this.#SplitDesktopVersion(version2)

    if (version1Numbers.length !== 4 || version2Numbers.length !== 4) {
      throw 'size of desktop version numbers must be 4!'
    }

    for (let i = 0; i < 4; ++i) {
      if (version1Numbers[i] > version2Numbers[i]) {
        return 1
      }

      if (version1Numbers[i] < version2Numbers[i]) {
        return -1
      }
    }

    return 0
  }

  /*
  @description 获取或创建IDesktopClient实例对象
  @params void
  @
  @return IDesktopClient实例对象
  */
  async GetClient() {
    let desktopVersion = '-.-.-.-'
    if (typeof this.client === 'undefined' || this.client === null) {
      for (let i = this.availableClientTypes.length - 1; i >= 0; --i) {
        const sinceVersion = this.availableClientTypes[i].sinceVersion
        const availableClient = new this.availableClientTypes[i].clientType()

        const desktopInfoResult = await availableClient.GetDesktopInfo()
        if (desktopInfoResult.code !== 'success') {
          continue
        }

        desktopVersion = desktopInfoResult.data.desktopVersion
        const compareResult = this.#CompareDesktopVersion(
          desktopVersion,
          sinceVersion
        )
        if (compareResult > 0 || compareResult === 0) {
          this.client = availableClient
          console.info(
            `desktop version:'${desktopVersion}', DesktopClient created from Type '${this.availableClientTypes[i].clientType.name}'`
          )
          break
        }
      }
    }

    if (typeof this.client === 'undefined' || this.client === null) {
      this.client = new DesktopClient_None()
      console.info(
        `desktop version:'${desktopVersion}', DesktopClient created from Type '${DesktopClient_None.name}'`
      )
    }

    return this.client
  }
}

/*
@description 初始化DesktopClient实例对象
@params errorHandler:Function 错误处理回调函数, 其签名为: (errorCode:String, errorMessage:String) -> void
@
@return IDesktopClient实例对象
*/
async function InitDesktopClient(errorHandler) {
  // 向DesktopClient实例注册错误处理回调
  const desktopClient = await DesktopClientFactory.Factory.GetClient()
  desktopClient.SetErrorHandler(errorHandler)
  return desktopClient
}

export { InitDesktopClient }
